import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [selected, setSelected] = useState(null);
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');

  function handleLogin() {
    if (!selected) { setError('Please select Traverser 1 or Traverser 2'); return; }
    const ok = login(selected, password);
    if (!ok) setError('Incorrect password. Please try again.');
  }

  function handleKey(e) {
    if (e.key === 'Enter') handleLogin();
  }

  return (
    <div className="login-page">
      <div className="login-logo">TAS</div>
      <div className="login-title">Traverser Alert</div>
      <div className="login-sub">Railway Workshop Control System</div>

      <div className="login-card">
        <span className="login-label">Select your traverser</span>
        <div className="traverser-btns">
          <button
            className={`t-btn t1 ${selected === 'T1' ? 'selected' : ''}`}
            onClick={() => { setSelected('T1'); setError(''); }}
          >
            <div className="t-label">T1</div>
            <div className="t-sub">Traverser 1</div>
            <div style={{ fontSize: 9, marginTop: 4, opacity: 0.8 }}
              className="t-sub">F1–F20</div>
          </button>
          <button
            className={`t-btn t2 ${selected === 'T2' ? 'selected' : ''}`}
            onClick={() => { setSelected('T2'); setError(''); }}
          >
            <div className="t-label">T2</div>
            <div className="t-sub">Traverser 2</div>
            <div style={{ fontSize: 9, marginTop: 4, opacity: 0.8 }}
              className="t-sub">F11–F20</div>
          </button>
        </div>

        <span className="login-label">Password</span>
        <div className="pw-field">
          <input
            type={showPw ? 'text' : 'password'}
            placeholder="Enter password"
            value={password}
            onChange={e => { setPassword(e.target.value); setError(''); }}
            onKeyDown={handleKey}
            autoComplete="current-password"
          />
          <button className="pw-toggle" onClick={() => setShowPw(p => !p)} type="button">
            {showPw
              ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
              : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            }
          </button>
        </div>

        {error && <div className="login-error">{error}</div>}

        <button className="btn-primary" onClick={handleLogin}>
          {selected ? `Login as ${selected === 'T1' ? 'Traverser 1' : 'Traverser 2'}` : 'Login'}
        </button>
      </div>
    </div>
  );
}
